if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.mobileItems = parseInt(this.dataset.mobileItems || '1', 10);
        this.enableSliderMobile = this.dataset.enableSliderMobile !== 'false';

        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplayOnMobile = this.dataset.autoplayOnMobile === 'true';
        this.autoplayDelay = parseInt(this.dataset.autoplayDelay || '3000', 10);
        this.autoplayPauseOnHover = this.dataset.autoplayPauseOnHover !== 'false';

        this.autoplayTimer = null;
        this.onMouseEnterAutoplay = null;
        this.onMouseLeaveAutoplay = null;

        this.autoplayTimer = null;
        this.onMouseEnterAutoplay = null;
        this.onMouseLeaveAutoplay = null;


        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
  const isMobile = FoxTheme.config.mqlMobile;

  // Si mobile et slider mobile désactivé => pas de slider
  if (isMobile && !this.enableSliderMobile) {
    this.destroySlider();
    return;
  }

  // Sinon on initialise le slider (desktop ou mobile autorisé)
  this.initSlider();
}


      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        const autoplayEnabled = this.dataset.autoplay === 'true';
const autoplayDelay = parseInt(this.dataset.autoplayDelay || '3000', 10);
const autoplayPauseOnHover = this.dataset.autoplayPauseOnHover !== 'false';

this.sliderOptions = {
  slidesPerView: this.mobileItems,
  spaceBetween: spaceBetween,
  navigation: {
    nextEl: this.section.querySelector(this.selectors.nextEl),
    prevEl: this.section.querySelector(this.selectors.prevEl),
  },
  pagination: false,
  breakpoints: {
    768: {
      slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
    },
    1280: {
      slidesPerView: parseInt(this.items),
    },
  },
  loop: true,
  threshold: 2,

  ...(autoplayEnabled
    ? {
        autoplay: {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: autoplayPauseOnHover,
        },
      }
    : {}),
};


        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
        this.startAutoplay();
        this.bindTouchAutoplay();

        this.calcNavButtonsPosition();
        this.calcHeadingColumnHeight();
        this.fixQuickviewDuplicate();
      }

      startAutoplay() {
  if (!this.sliderInstance || !this.sliderInstance.slider) return;

  const isMobile = FoxTheme.config.mqlMobile;
  const shouldAutoplay = this.autoplayEnabled && (!isMobile || this.autoplayOnMobile);

  if (!shouldAutoplay) return;

  this.stopAutoplay();

  this.autoplayTimer = window.setInterval(() => {
    if (!this.sliderInstance || !this.sliderInstance.slider) return;
    this.sliderInstance.slider.slideNext();
  }, this.autoplayDelay);

  // Pause au hover seulement sur desktop (sur mobile ça n'a pas de sens)
  if (!isMobile && this.autoplayPauseOnHover) {
    this.onMouseEnterAutoplay = () => this.stopAutoplay();
    this.onMouseLeaveAutoplay = () => this.startAutoplay();

    this.addEventListener('mouseenter', this.onMouseEnterAutoplay);
    this.addEventListener('mouseleave', this.onMouseLeaveAutoplay);
  }
}

stopAutoplay() {
  if (this.autoplayTimer) {
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  if (this.onMouseEnterAutoplay) {
    this.removeEventListener('mouseenter', this.onMouseEnterAutoplay);
    this.onMouseEnterAutoplay = null;
  }

  if (this.onMouseLeaveAutoplay) {
    this.removeEventListener('mouseleave', this.onMouseLeaveAutoplay);
    this.onMouseLeaveAutoplay = null;
  }
}

bindTouchAutoplay() {
  if (!this.autoplayEnabled) return;

  this._onTouchStart = () => this.stopAutoplay();
  this._onTouchEnd = () => this.startAutoplay();

  this.addEventListener('touchstart', this._onTouchStart, { passive: true });
  this.addEventListener('touchend', this._onTouchEnd, { passive: true });
}

unbindTouchAutoplay() {
  if (this._onTouchStart) {
    this.removeEventListener('touchstart', this._onTouchStart);
    this._onTouchStart = null;
  }
  if (this._onTouchEnd) {
    this.removeEventListener('touchend', this._onTouchEnd);
    this._onTouchEnd = null;
  }
}


      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.stopAutoplay();
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.stopAutoplay();
        this.unbindTouchAutoplay();
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }

      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
        }
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
